
<h6 :class="error ? `error` : `title`">
  <slot>{{ title }}</slot>
</h6>
